// What the areas can be coloured by (checkedState keys), with the short label and the short explanation
// shown in the Färgkarta menu's tooltips and the legend's info icon. Keep them to a few words: the scale
// already says each is relative to nearby areas.
export const COLOUR_METRIC_INFO = {
    totalScore: {
        sv: 'Betyg',
        en: 'Total score',
        descSv: 'Allt vägt ihop till ett betyg.',
        descEn: 'Everything combined into one score.',
    },
    squareMeterPriceApartment: {
        sv: 'Lägenhet kr/m²',
        en: 'Apartment SEK/m²',
        descSv: 'Lägenhetspris per kvadratmeter.',
        descEn: 'Apartment price per square metre.',
    },
    squareMeterPriceHouse: {
        sv: 'Villa kr/m²',
        en: 'House SEK/m²',
        descSv: 'Villapris per kvadratmeter.',
        descEn: 'House price per square metre.',
    },
    income: {
        sv: 'Inkomst',
        en: 'Income',
        descSv: 'Inkomst efter skatt.',
        descEn: 'Income after tax.',
    },
    unemployment: {
        sv: 'Arbetslöshet',
        en: 'Unemployment',
        descSv: 'Andel arbetslösa.',
        descEn: 'Share unemployed.',
    },
    ownedVsRented: {
        sv: 'Ägande',
        en: 'Ownership',
        descSv: 'Andel ägda bostäder.',
        descEn: 'Share of owned homes.',
    },
    education: {
        sv: 'Utbildning',
        en: 'Education',
        descSv: 'Andel med högre utbildning.',
        descEn: 'Share with higher education.',
    },
};

export const colourMetricLabel = (key, swedish) => {
    const info = COLOUR_METRIC_INFO[key];
    return info ? (swedish ? info.sv : info.en) : '';
};

export const colourMetricDescription = (key, swedish) => {
    const info = COLOUR_METRIC_INFO[key];
    return info ? (swedish ? info.descSv : info.descEn) : '';
};
